import brandConfig from "../config/brandConfig";

/**
 * Keeps legacy translations usable while preventing partner deployments from
 * showing another distribution brand. New copy should use i18next variables.
 */
export const formatBrandCopy = (copy?: string | null): string => {
  if (!copy) return "";

  return copy
    .replace(/BioCV(?:\s+CalfHealth)?/gi, brandConfig.name)
    .replace(/BioTag\+/gi, brandConfig.name)
    .replace(/CalfHealth/gi, brandConfig.name);
};

